module.exports = __webpack_public_path__ + "media/prk/assets/images/icons/info-333f1c4442642d9319ef00dd77c42b73.svg";